

import {
    Component,
    OnInit,
  } from "@angular/core";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
      DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
  import * as Leaflet from "leaflet";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { ScuolaDTO } from "src/app/models/scuola.model";
import { environment } from "src/environments/environment";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { PraticheService } from "src/app/services/pratiche.service";
import { PraticaScuola } from "src/app/models/pratica.scuola.model";
import { Centrale } from "src/app/models/centrale.models";
import { ComuneDTO } from "src/app/models/comune.model";
import { DettaglioPraticaScuolaDTO } from "src/app/models/dettaglioPratica.scuola.model";
import { Pratica } from "src/app/models/pratica.model";
import { ModificaPosizioneScuola } from "../../../shared/modifica-posizione-scuola/modifica-posizione-scuola.component";
import { DialogRichiediAggiornamentoCentrale } from "src/app/pages/pratiche/scuola/bando2/aggiornamento-centrale-bando2.component";

interface TipoBackup {
    id: number;
    codice: string;
  }
  

@Component({
  selector: "component-informazioni-fase3-bando1",
  templateUrl: "./dialog-inserisci-informazioni-pratica.component.html",
  styleUrls: ["../fase3.bando1.component.css"],
})
export class DialogInformazioniFase3Bando1 implements OnInit {
  protected _onDestroy = new Subject<void>();
  public pratica: Pratica;
  public praticaFromFirestore: PraticaFlowdy2_Firestore;
  selectedFile: File = null;
  isFileUploaded: boolean = false;
  isLoadingResults: boolean = false;
  protected pagineInserisciInformazioni: MenuItem[];
  protected activeIndex: number = 0;

  protected reteAccessoForm: FormGroup;
  protected ubicazioneRouterForm: FormGroup;
  protected identificazioneFibraFormB: FormGroup;
  protected identificazioneFibraFormAC: FormGroup;
  protected localizzazioniForm: FormGroup;
  protected dettagliForm: FormGroup;
  private scuola: ScuolaDTO;
  private isTipoB:Boolean=false;
  private isTipoAC:Boolean=false;
  private isTipoBFromC:Boolean = false;
  protected ref: DynamicDialogRef;
  private collection_pratiche_scuola:string = environment.firebase.collection_pratiche;

  private tipiBackup:TipoBackup[];

  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _formBuilder: FormBuilder,
    private praticheScuolaService: PraticheService,
    private messageService: MessageService,
    public dialogService: DialogService,
    private firestoreService:AngularFirestore
  ) {
    this.tipiBackup = [
      { id: 1, codice: 'FO' },
      { id: 2, codice: 'LTE' },
      { id: 3, codice: 'NESSUNO' }
     
    ];
  }

  ngOnInit(): void {
    this.pratica = this.config.data.pratica;
    this.logger.info(this.pratica.datiFase3);
    this.praticaFromFirestore = this.config.data.praticaFromFirestore;
    if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('C') || this.praticaFromFirestore.tipoSedeEffettiva.endsWith('A')){
      this.isTipoAC = true;
    }else if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('B') ){
      this.isTipoB = true;
      if(this.pratica.tipoSedeGara.codice.endsWith('C')){
        this.isTipoBFromC = true;
      }

      
    }
    
    if(this.isTipoAC){
      this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA AC ");
    }else if(this.isTipoB){
      this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA B ");
      if(this.isTipoBFromC){
        this.logger.info("ON INIT @ DETTAGLI DI UNA PRATICA B FROM C ");
      }
    
    }
    this.scuola = this.config.data.scuola;
    this.inizializzaFormGroups();
    this.inizializzaSteps();
  }

  getTipoBackup(tipologia:String):number{
    switch (tipologia) {
      case "FO":
        return 0;
      case "LTE":
        return 1;
      case "NESSUNO":
        return 2;
      default:
        return null;
    }
  }

  inizializzaFormGroups() {
   /*  this.reteAccessoForm = this._formBuilder.group({
      tipologia: [this.scuola.tipologia, [Validators.required]],
      diritto: [this.scuola.proprietario, [Validators.required]],
      proprietario: [this.scuola.proprietario, [Validators.required]],
      numeroAccessPoints: [
        this.scuola.numeroAccessPoint,
        [Validators.required],
      ],
    }); */
    this.dettagliForm = this._formBuilder.group({
      annoAttivazione:      [ this.pratica.annoAttivazione, [Validators.required]],
      hostnameCPE:      [ this.scuola.hostnameCpe, [Validators.required]],
      ipAddress:        [ this.scuola.ipAddress, [Validators.required]],
      localeTecnico:    [ this.scuola.localeTecnicoNome, [Validators.required]],
      piano:            [ this.scuola.localeTecnicoPiano, [Validators.required]],
      stanza:           [ this.scuola.localeTecnicoStanza, [Validators.required]],
      redattore:        [ this.pratica.datiFase3.redattore, [Validators.required]],
      verificatore:     [ this.pratica.datiFase3.verificatore, [Validators.required]],
   //   backup:           [ this.pratica.backup, [Validators.required]],
    //  wifi:             [ this.pratica.wifi, [Validators.required]],

    });
    if(!this.isTipoAC){
     // this.logger.info("inizializzaFormGroups DI UNA PRATICA B "+ this.pratica.tipoBSharp + " con tipo bu "+ this.scuola.tipoBackup);
      this.identificazioneFibraFormB = this._formBuilder.group({
        clliSedeA:                  [ this.scuola.clliSedeA, [Validators.required]],
        tipologiaSedeA:             [ this.scuola.tipologiaSedeA, [Validators.required]],
        descrizioneSedeA:           [ this.scuola.descrizioneSedeA, [Validators.required]],
        attestazioneAlRipartitoreA: [ this.scuola.attestazioneRipartitoreA,  [Validators.required], ],
  
        clliSedeZ:                  new FormControl({value: this.pratica.centrale.clli, disabled: true}, Validators.required),
        tipologiaSedeZ:             [ this.scuola.tipologiaSedeZ, [Validators.required]],
        descrizioneSedeZ:           [ this.scuola.descrizioneSedeZ, [Validators.required]],
        attestazioneAlRipartitoreZ: [ this.scuola.attestazioneRipartitoreZ,[Validators.required], ],
  
        numeroTotaleCoppie: [ this.scuola.numeroTotaleCoppie, [Validators.required],],
        numeroCoppieInUso:  [ this.scuola.numeroCoppieInUso, [Validators.required]],
        fibra:              [ this.scuola.numeroFibra, [Validators.required]],
        lunghezza:         [ this.scuola.lunghezza, [Validators.required]],
        tipoBackup: [ this.scuola.tipoBackup?this.tipiBackup[this.getTipoBackup(this.scuola.tipoBackup)]:this.tipiBackup[this.getTipoBackup("NESSUNO")], [Validators.required]],
        tipoBSharp:       [ this.pratica.tipoBSharp?this.pratica.tipoBSharp:false, [Validators.required]],});
        
    
     
      
    }else {
      this.logger.info("inizializzaFormGroups DI UNA PRATICA AC con tipo bu "+ this.scuola.tipoBackup);
      this.identificazioneFibraFormAC = this._formBuilder.group({
       
        attestazioneAlRipartitoreA: [ this.scuola.attestazioneRipartitoreA,  [Validators.required], ],
        attestazioneAlRipartitoreZ: [ this.scuola.attestazioneRipartitoreZ,[Validators.required], ],
        fibra:                      [ this.scuola.numeroFibra, [Validators.required]],
        clliSedeZ:                  new FormControl({value: this.scuola.clliSedeZ?this.scuola.clliSedeZ:this.pratica.centrale.clli, disabled: true}, Validators.required),
        idPCN:                      [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.codice:null,         [Validators.required]],
        indirizzoPCN:               [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.indirizzo:null,         [Validators.required]],
        nomePCN :                   [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.nome:null,       [Validators.required]],
        latitudinePCN :             [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.latitudine:null, [Validators.required]],
        longitudinePCN:             [ this.pratica.datiFase3.pcn?this.pratica.datiFase3.pcn.longitudine:null,[Validators.required]],
        lunghezza:          [ this.scuola.lunghezza, [Validators.required]],
        tipoBackup: [ this.scuola.tipoBackup?this.tipiBackup[this.getTipoBackup(this.scuola.tipoBackup)]:this.tipiBackup[this.getTipoBackup("NESSUNO")], [Validators.required]],
      });
    }
   
    
    this.localizzazioniForm = this._formBuilder.group({
      indirizzoScuola:      [ this.scuola.indirizzo, [Validators.required]],
      comuneScuola:         [ this.scuola.comune.denominazione, [Validators.required]],
      latitudineScuola:     [ this.praticaFromFirestore.coordinateScuola?this.praticaFromFirestore.coordinateScuola.latitude:null, [Validators.required]],
      longitudineScuola:    [ this.praticaFromFirestore.coordinateScuola? this.praticaFromFirestore.coordinateScuola.longitude:null, [Validators.required]],
     
      indirizzoCentrale: new FormControl({value: this.pratica.centrale.indirizzo, disabled: true}, Validators.required),
      latitudineCentrale:  new FormControl({value: this.pratica.centrale?this.pratica.centrale.latitudine:null, disabled: true}, Validators.required),
      longitudineCentrale:  new FormControl({value: this.pratica.centrale?this.pratica.centrale.longitudine:null, disabled: true}, Validators.required),
      comuneCentrale:       new FormControl({value: this.pratica.centrale.comune.denominazione, disabled: true}, Validators.required),
     
    });
    
  }
  inizializzaSteps() {
    this.pagineInserisciInformazioni = [
   
      {
        label: "Dettagli",
      },
      
      {
        label: "Identificazione Fibra",
      },
      {
        label: "Localizzazioni",
      }
    ];
    this.activeIndex = 0;
  }

  checkNextStep(): boolean {
    let disableNextStepButton = false;
    if (this.activeIndex === this.pagineInserisciInformazioni.length - 1) {
      disableNextStepButton = true;
    } else if (this.activeIndex === 1 && !this.dettagliForm.valid) {
      disableNextStepButton = true;
    }/*  else if (this.activeIndex === 1 && !this.ubicazioneRouterForm.valid) {
      disableNextStepButton = true;
    } */ else if (this.activeIndex === 0 ) {
      if(!this.isTipoAC && !this.identificazioneFibraFormB.valid ){
        disableNextStepButton = true;
      }else if(this.isTipoAC && !this.identificazioneFibraFormAC.valid){
        disableNextStepButton = true;
      }
      
    } else if (this.activeIndex === 2 && !this.localizzazioniForm.valid) {
      disableNextStepButton = true;
    } /* else if (this.activeIndex === 3 && !this.dettagliForm.valid) {
      disableNextStepButton = true;
    } */

    return disableNextStepButton;
  }

  changePage() {
    this.activeIndex = this.activeIndex + 1;
  }
  openMappaScuola(){
    this.logger.info("---OPENMAPPA SCUOLA----");
    this.ref = this.dialogService.open(ModificaPosizioneScuola, {
          data: {
            pratica: this.praticaFromFirestore,
            isScuola: true,
          },
          header:
            "Modifica la posizione della scuola " + this.praticaFromFirestore.cui,
          width: "70%",
          height: "95%",
          baseZIndex: 10000,
          closable: true,
          draggable: false,
        });
        this.ref.onClose.subscribe((changeResult) => {
          this.logger.info("CHIUDO MAPPA " + changeResult);
          const collectionRef = this.firestoreService.collection(
            this.collection_pratiche_scuola
          );
          const documentRef = collectionRef.doc(this.pratica.cui.valueOf());
          documentRef.get().subscribe((res) => {
            this.praticaFromFirestore = res.data() as PraticaFlowdy2_Firestore;
            this.localizzazioniForm
              .get("latitudineScuola")
              .setValue(this.praticaFromFirestore.coordinateScuola.latitude);
            this.localizzazioniForm
              .get("longitudineScuola")
              .setValue(this.praticaFromFirestore.coordinateScuola.longitude);
          });
        });
    /* this.ref = this.dialogService.open(DialogModificaPosizioneBando1, {
      data: {
        pratica: this.praticaFromFirestore,
        isScuola:true,
      },
      header: "Posizione della scuola",
      width: "70%",
      height: "75%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((changeResult) => {
      this.logger.info("CHIUDO MAPPA "+ changeResult);
      const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
      const documentRef   = collectionRef.doc(this.pratica.codiceInfratel.valueOf());
      documentRef.get().subscribe(res => {
        this.praticaFromFirestore =  res.data() as PraticaScuola_Firestore;
        this.localizzazioniForm.get("latitudineScuola").setValue(this.praticaFromFirestore.coordinateScuola.latitude);
        this.localizzazioniForm.get("longitudineScuola").setValue(this.praticaFromFirestore.coordinateScuola.longitude);
      });
    }); */
  }
  openMappaCentrale(){
    this.logger.info("---OPENMAPPA CENTRALE----");
    /* this.ref = this.dialogService.open(DialogModificaPosizioneBando1, {
      data: {
        pratica: this.praticaFromFirestore,
        isScuola:false,
      },
      header: "Posizione della centrale",
      width: "70%",
      height: "75%",
      baseZIndex: 10000,
      closable: true,
      draggable: false,
    });
    this.ref.onClose.subscribe((changeResult) => {
      this.logger.info("CHIUDO MAPPA "+ changeResult);
      const collectionRef = this.firestoreService.collection(this.collection_pratiche_scuola);
      const documentRef   = collectionRef.doc(this.pratica.codiceInfratel.valueOf());
      documentRef.get().subscribe(res => {
        this.praticaFromFirestore =  res.data() as PraticaScuola_Firestore;
        this.localizzazioniForm.get("latitudineCentrale").setValue(this.praticaFromFirestore.coordinateCentrale.latitude);
        this.localizzazioniForm.get("longitudineCentrale").setValue(this.praticaFromFirestore.coordinateCentrale.longitude);
      });
    }); */
  }

  openRichiediAggiornamentoDatiCentrale(){
    let centrale:Centrale = new Centrale();
    let comune:ComuneDTO = new ComuneDTO();
    comune.denominazione = this.pratica.comuneCentrale;
    centrale.clli = this.pratica.centrale.clli;
    centrale.indirizzo = this.pratica.centrale.indirizzo;
    centrale.comune = this.pratica.centrale.comune;
    centrale.latitudine = this.pratica.centrale.latitudine;
    centrale.longitudine = this.pratica.centrale.longitudine;

      this.ref = this.dialogService.open(DialogRichiediAggiornamentoCentrale, {
        data: {
          centrale: centrale,
          impresa:this.pratica.azienda.ragioneSociale,
    },
      header: 'Richiedi aggiornamento Centrale ' + this.pratica.centrale.clli.toUpperCase(),//+impresa.ragioneSociale.toUpperCase(),
      width: '50%',
      height: '70%',
      baseZIndex: 10000,
      closable:true,
      draggable:false,
    });
    this.ref.onClose.subscribe(confirmModificaCliente => {

    }); 
}
validateYearInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  let value = input.value;

  // Rimuove qualsiasi carattere che non sia un numero
  value = value.replace(/[^0-9]/g, '');

  // Limita il valore a 4 cifre
  if (value.length > 4) {
    value = value.slice(0, 4);
  }

  input.value = value;
  this.dettagliForm.get('annoAttivazione')?.setValue(value);
}

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      let dettaglioPraticaDTO: DettaglioPraticaScuolaDTO = new DettaglioPraticaScuolaDTO();
      dettaglioPraticaDTO.id = this.pratica.id;
      dettaglioPraticaDTO.codiceInfratel = this.pratica.cui;
      dettaglioPraticaDTO.hostnameCPE                 = this.dettagliForm.value.hostnameCPE;
      dettaglioPraticaDTO.annoAttivazione             = this.dettagliForm.value.annoAttivazione;
      dettaglioPraticaDTO.ipAddress                   = this.dettagliForm.value.ipAddress;

      dettaglioPraticaDTO.localeTecnico               = this.dettagliForm.value.localeTecnico;
      dettaglioPraticaDTO.piano                       = this.dettagliForm.value.piano;
      dettaglioPraticaDTO.stanza                      = this.dettagliForm.value.stanza;
      dettaglioPraticaDTO.redattore                   = this.dettagliForm.value.redattore;
      dettaglioPraticaDTO.verificatore                = this.dettagliForm.value.verificatore;
      dettaglioPraticaDTO.wifi                        = this.dettagliForm.value.wifi;
      //dettaglioPraticaDTO.backup                      = this.dettagliForm.value.backup;

      if(!this.isTipoAC){
        this.logger.info("CONFERMO TIPO B");
        dettaglioPraticaDTO.clliSedeA                   = this.identificazioneFibraFormB.value.clliSedeA;
        dettaglioPraticaDTO.tipologiaSedeA              =  this.identificazioneFibraFormB.value.tipologiaSedeA;
        dettaglioPraticaDTO.descrizioneSedeA            =  this.identificazioneFibraFormB.value.descrizioneSedeA;
        dettaglioPraticaDTO.attestazioneAlRipartitoreA  =  this.identificazioneFibraFormB.value.attestazioneAlRipartitoreA;
        
        dettaglioPraticaDTO.clliSedeZ                   =  this.identificazioneFibraFormB.value.clliSedeZ;
        dettaglioPraticaDTO.tipologiaSedeZ              = this.identificazioneFibraFormB.value.tipologiaSedeZ;
        dettaglioPraticaDTO.descrizioneSedeZ            = this.identificazioneFibraFormB.value.descrizioneSedeZ;
        dettaglioPraticaDTO.attestazioneAlRipartitoreZ  = this.identificazioneFibraFormB.value.attestazioneAlRipartitoreZ;

        dettaglioPraticaDTO.numeroTotaleCoppie          = this.identificazioneFibraFormB.value.numeroTotaleCoppie;
        dettaglioPraticaDTO.numeroCoppieInUso           = this.identificazioneFibraFormB.value.numeroCoppieInUso;
        dettaglioPraticaDTO.fibra                       = this.identificazioneFibraFormB.value.fibra;
        //if(this.isTipoB){
        dettaglioPraticaDTO.lunghezza                   = this.identificazioneFibraFormB.value.lunghezza;
        if(this.identificazioneFibraFormB.value.tipoBackup && this.identificazioneFibraFormB.value.tipoBackup.codice!="NESSUNO"){
          dettaglioPraticaDTO.tipoBackup      = this.identificazioneFibraFormB.value.tipoBackup.codice;
          dettaglioPraticaDTO.backup          = "true"; 
        }else{
          dettaglioPraticaDTO.tipoBackup      = "";
          dettaglioPraticaDTO.backup          = "false";
        }
        if(this.isTipoBFromC){
          dettaglioPraticaDTO.tipoBSharp  = this.identificazioneFibraFormB.value.tipoBSharp;
        }
       // }
        //
      }else{
        this.logger.info("CONFERMO TIPO AC");
        dettaglioPraticaDTO.attestazioneAlRipartitoreA  =  this.identificazioneFibraFormAC.value.attestazioneAlRipartitoreA;
        dettaglioPraticaDTO.attestazioneAlRipartitoreZ  = this.identificazioneFibraFormAC.value.attestazioneAlRipartitoreZ;
        dettaglioPraticaDTO.fibra                       = this.identificazioneFibraFormAC.value.fibra;
        dettaglioPraticaDTO.clliSedeZ                   =  this.identificazioneFibraFormAC.value.clliSedeZ;
        dettaglioPraticaDTO.idPCN                       = this.identificazioneFibraFormAC.value.idPCN;
        dettaglioPraticaDTO.indirizzoPCN                = this.identificazioneFibraFormAC.value.indirizzoPCN;
        dettaglioPraticaDTO.nomePCN                     = this.identificazioneFibraFormAC.value.nomePCN;
        dettaglioPraticaDTO.latitudinePCN               = this.identificazioneFibraFormAC.value.latitudinePCN;
        dettaglioPraticaDTO.longitudinePCN              = this.identificazioneFibraFormAC.value.longitudinePCN;
        dettaglioPraticaDTO.lunghezza                   = this.identificazioneFibraFormAC.value.lunghezza;
        if(this.identificazioneFibraFormAC.value.tipoBackup && this.identificazioneFibraFormAC.value.tipoBackup.codice!="NESSUNO"){
          dettaglioPraticaDTO.tipoBackup      = this.identificazioneFibraFormAC.value.tipoBackup.codice;
          dettaglioPraticaDTO.backup          = "true"; 
        }else{
          dettaglioPraticaDTO.tipoBackup      = "";
          dettaglioPraticaDTO.backup          = "false";
        }
      }
      
      

      dettaglioPraticaDTO.indirizzoScuola   = this.localizzazioniForm.value.indirizzoScuola;
      dettaglioPraticaDTO.comuneScuola      = this.localizzazioniForm.value.comuneScuola;
      dettaglioPraticaDTO.latitudineScuola  =  this.localizzazioniForm.value.latitudineScuola;
      dettaglioPraticaDTO.longitudineScuola =  this.localizzazioniForm.value.longitudineScuola;

      dettaglioPraticaDTO.indirizzoCentrale =  this.localizzazioniForm.value.indirizzoCentrale;
      dettaglioPraticaDTO.comuneCentrale    = this.localizzazioniForm.value.comuneCentrale;
      dettaglioPraticaDTO.latitudineCentrale = this.localizzazioniForm.value.latitudineCentrale;
      dettaglioPraticaDTO.longitudineCentrale =  this.localizzazioniForm.value.longitudineCentrale;
     
      this.logger.info(dettaglioPraticaDTO);

       this.praticheScuolaService
        .caricaDettagliPratica(dettaglioPraticaDTO)
        .subscribe({
          next: (v) => {},
          error: (e) => {
            this.messageService.add({
              severity: "info",
             summary: "Errore" , life:10000,
              detail: "Errore in fase di AGGIORNAMENTO DELLE INFORMAZIONI FASE 3 della pratica",
            });
            this.dialogRef.close({ success: false });
          },
          complete: () => {
            this.dialogRef.close({ success: true });
             this.messageService.add({
                severity: "success",
                summary: "" , life:10000,
                detail: "INFORMAZIONI FASE 3 della pratica aggiornate con successo",
              }); 
          },
        }); 
    }
  }
}